const forms = {
  state: {
    maintStrategyDID: null,
    maintPlanDID: null,
    maintCall: null,
    maintActivityList: null,
    maintActivityListCounter: null
  },
  mutations: {
    changeMaintPlanDID(state, payload) {
      state.maintPlanDID = payload;
    },
    changeMaintStrategyDID(state, payload) {
      state.maintStrategyDID = payload;
    },
    changeMaintCall(state, payload) {
      state.maintCall = payload;
    },
    changeMaintActivityList(state, payload) {
      state.maintActivityList = payload;
    },
    changeMaintActivityListCounter(state, payload) {
      state.maintActivityListCounter = payload;
    }
  },
  actions: {
    changeMaintPlanDID({ commit }, payload) {
      commit("changeMaintPlanDID", payload);
    },
    changeMaintStrategyDID({ commit }, payload) {
      commit("changeMaintStrategyDID", payload);
    },
    changeMaintCall({ commit }, payload) {
      commit("changeMaintCall", payload);
    },
    changeMaintActivityList({ commit }, payload) {
      commit("changeMaintActivityList", payload);
    },
    changeMaintActivityListCounter({ commit }, payload) {
      commit("changeMaintActivityListCounter", payload);
    }
  },
  getters: {
    getMaintPlanDID: state => {
      return state.maintPlanDID;
    },
    getMaintStrategyDID: state => {
      return state.maintStrategyDID;
    },
    getMaintCall: state => {
      return state.maintCall;
    },
    getMaintActivityList: state => {
      return state.maintActivityList;
    },
    getMaintActivityListCounter: state => {
      return state.maintActivityListCounter;
    }
  }
};
// eslint-disable-next-line
export default forms;
